import React, { useContext } from 'react';

import RouterFactory from '../../routing/child-router-factory';

import { createConfig } from './route-config';

import { RouterContext } from '../../context/routing';

const HaulerRouter = () => {
  const routing = useContext(RouterContext);

  const map = routing?.routingMap;
  return (
    <RouterFactory
      config={createConfig(map)}
      basePath={map.hauler._}
      defaultRedirect={map.hauler.properties._}
    />
  );
};

export default HaulerRouter;
